module.exports = __webpack_public_path__ + "img/il_empty_folder_2.0b5862dc.svg";